import { render, staticRenderFns } from "./OnePersonOneFile.vue?vue&type=template&id=41e82b0d&scoped=true&"
import script from "./OnePersonOneFile.vue?vue&type=script&lang=js&"
export * from "./OnePersonOneFile.vue?vue&type=script&lang=js&"
import style0 from "./OnePersonOneFile.vue?vue&type=style&index=0&id=41e82b0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e82b0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e82b0d')) {
      api.createRecord('41e82b0d', component.options)
    } else {
      api.reload('41e82b0d', component.options)
    }
    module.hot.accept("./OnePersonOneFile.vue?vue&type=template&id=41e82b0d&scoped=true&", function () {
      api.rerender('41e82b0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/OnePersonOneFile.vue"
export default component.exports